import axios from 'axios'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'

const getFeatureFlag = async (
  flagName: string,
  contextObject?: Record<string, string>,
) => {
  const { data } = await axios.post(
    `${buildURL('featureFlag', apiConfig.unleash)}?flagName=${flagName}`,
    contextObject,
  )
  return data
}

export default getFeatureFlag
